<template>
    <Transition
        name="fade"
        :mode
    >
        <slot
            v-if="!transition || state === 'success'"
            name="default"
        />

        <slot
            v-else-if="state === 'pending' || state === 'idle'"
            name="loading"
        >
            <div />
        </slot>

        <slot
            v-else-if="state === 'error'"
            name="error"
        >
            <PageError :status-code="statusCode" />
        </slot>
    </Transition>
</template>

<script setup lang="ts">
import type { AsyncDataRequestStatus } from '#app';

interface Props {
    state?: AsyncDataRequestStatus;
    statusCode?: number;
    transition?: boolean;
    mode?: 'default' | 'in-out' | 'out-in' | undefined;
}

const props = withDefaults(
    defineProps<Props>(),
    {
        state: undefined,
        statusCode: 0,
        transition: true,
        mode: 'out-in',
    }
);

const { state, transition } = toRefs(props);
</script>
